import Version from './lib/Version';

class App {
  init(
    appVersionString,
    databaseVersionString,
    tessituraVersionString,
    environment,
    rootUrl,
    isVersionSevenEnabled
  ) {
    this.appVersion = Version.fromString(appVersionString);
    this.databaseVersion = Version.fromString(databaseVersionString);
    this.tessituraVersion = Version.fromString(tessituraVersionString);
    this.environment = environment;
    this.rootUrl = rootUrl;
    this.isVersionSevenEnabled = isVersionSevenEnabled;
  }

  getRootUrl() {
    return this.rootUrl;
  }
}

export default App;



// WEBPACK FOOTER //
// ./V7/tnew/App.js